'use strict';

const BaseForwardingAddressModalController=require('./baseForwardingAddressModalController');let

AddForwardingAddressModalController=class AddForwardingAddressModalController extends BaseForwardingAddressModalController{
static get $inject(){
return['$modalInstance','socketService','uiCommandFactory','onAddressListUpdated','notificationService','uncaughtErrorHandler'];
}

constructor($modalInstance,socketService,uiCommandFactory,onAddressListUpdated,notificationService,uncaughtErrorHandler){
super($modalInstance,socketService,uiCommandFactory,onAddressListUpdated,notificationService,uncaughtErrorHandler);
}

async onSubmissionSocketAction(){
return await this._socketService.sendAndWaitForResponse('AddNotificationForwardingAddress',this._emailAddress);
}};


module.exports=AddForwardingAddressModalController;
//# sourceMappingURL=addForwardingAddressModalController.js.map
